import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Spinner } from 'common/components/Spinner/Spinner';
import { useCompany } from 'modules/app/hooks/useCompany';
import { useFetchKycRemediation } from 'modules/invoices/hooks/useFetchKycRemediation';
import { routeFor, routes } from 'src/core/constants/routes';

/**
 * Route component that fetches the KYC remediation URL, opens it in a new tab,
 * and redirects the user back to the homepage.
 * This is specifically for use as a route, not for embedding in other components.
 */
export const KycRemediationRedirectRoute: React.FC = () => {
  const queryState = useFetchKycRemediation({ isEnabled: true });
  const history = useHistory();
  const company = useCompany();

  useEffect(() => {
    if (queryState.status === 'success') {
      if (queryState.data?.onboardingUrl) {
        window.location.href = queryState.data.onboardingUrl;
      } else {
        history.replace(
          routeFor(routes.HOMEPAGE.path, { company: company.id }),
        );
      }
    }
  }, [queryState, history, company.id]);

  useEffect(() => {
    if (queryState.status === 'error') {
      // Redirect to home on error
      history.replace(routeFor(routes.HOMEPAGE.path, { company: company.id }));
    }
  }, [queryState.status, history, company.id]);

  if (queryState.status === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <Spinner />
      </div>
    );
  }

  return null;
};
